const DEFAULT_STATE = {
  app: {
    version: 'V9-migration-scaffold',
    activeToolId: null,
  },
  ui: {
    leftPanelTab: 'home',
  },
  tools: {}, // toolId -> persisted data blob
};

export function createStore(events) {
  let state = structuredClone(DEFAULT_STATE);

  function getState() {
    return state;
  }

  function setState(updater, meta = {}) {
    const next = typeof updater === 'function' ? updater(structuredClone(state)) : updater;
    state = next;
    events.emit('state:changed', { state, meta });
  }

  function setToolState(toolId, toolState, meta = {}) {
    setState((s) => {
      s.tools[toolId] = toolState;
      return s;
    }, { ...meta, toolId });
  }

  function getToolState(toolId) {
    return state.tools[toolId] ?? null;
  }

  function reset() {
    setState(structuredClone(DEFAULT_STATE), { reason: 'reset' });
  }

  return { getState, setState, setToolState, getToolState, reset };
}
